import classNames from 'classnames';
import { FC, MouseEventHandler } from 'react';

import { IcClose16Icon } from '@gem/icons';

import { IconButton, IconViewSizes } from '../../IconButton/IconButton';
import { IconView } from '../../IconView/IconView';
import { IInputChipsItem, IInputChipsProps } from '../InputChips.types';
import styles from './InputChipsItem.styles.m.css';

interface IInputChipsItemProps
  extends IInputChipsItem,
    Pick<IInputChipsProps, 'onRemove' | 'onClick' | 'isDisabled'> {
  className?: string;
}

export const InputChipsItem: FC<IInputChipsItemProps> = (props) => {
  const {
    className,
    children,
    id,
    isDisabled,
    onRemove,
    onClick,
    theme = 'standard',
    Icon,
  } = props;
  const containerClassName = classNames(styles.container, className, styles[`theme-${theme}`], {
    [styles.withRemoveButton]: onRemove,
    [styles.disabled]: isDisabled,
  });

  const handleRemove: MouseEventHandler = (e) => {
    e.stopPropagation();
    onRemove?.(id);
  };

  const handleClick: MouseEventHandler = () => {
    onClick?.(id);
  };

  return (
    <div
      tabIndex={0}
      role="button"
      onClick={handleClick}
      className={containerClassName}
    >
      {!!Icon && (
        <IconView
          className={styles.icon}
          size={IconViewSizes.Small}
          Icon={Icon}
        />
      )}
      <div className={styles.content}>{children}</div>
      {onRemove && (
        <IconButton
          theme="15"
          size={IconViewSizes.XSmall}
          Icon={IcClose16Icon}
          onClick={handleRemove}
          className={styles.removeButton}
        />
      )}
    </div>
  );
};
